import type React from 'react';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { useAuth } from '@/provider/UserProvider';
import { likeAsset, unLikeAsset } from '@/services';
import type { NftMarket } from '@/types';
import { useSMutation } from '@/utils';

const useMarketplaceCard = (nftMarket: NftMarket) => {
  const { isLogin, auth } = useAuth();
  const { mutate: mutateLike } = useSMutation({ mutationFn: likeAsset });
  const { mutate: mutateUnlike } = useSMutation({
    mutationFn: unLikeAsset,
  });
  const [isLike, setIsLike] = useState(false);
  const [numberLike, setNumberLike] = useState(0);

  const { isNsfw } = nftMarket.asset;
  const isOwner = auth.user.publicAddress === nftMarket?.asset?.provider?.publicAddress;
  const isPlusUser = auth.user?.isPlus;

  const getIsLiked = () => {
    if (nftMarket) {
      if (!isLogin) setIsLike(false);
      else setIsLike(nftMarket.asset?.attributes?.isLiked ?? false);
      setNumberLike(nftMarket.asset?.attributes?.numberOfLikes ?? 0);
    }
  };

  useEffect(() => {
    getIsLiked();
  }, [isLogin, nftMarket]);

  const handleUnlike = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    if (!isLogin) return toast.error('You must login to continue!');
    setIsLike(!isLike);
    mutateUnlike(nftMarket.asset.id);
    setNumberLike((val) => val - 1);
  };

  const handleLike = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    if (!isLogin) return toast.error('You must login to continue!');
    setIsLike(!isLike);
    mutateLike(nftMarket.asset.id);
    setNumberLike((val) => val + 1);
  };

  return { handleLike, handleUnlike, isLike, numberLike, isNsfw, isOwner, isPlusUser };
};

export default useMarketplaceCard;
